import { render, staticRenderFns } from "./UdmGrammar.vue?vue&type=template&id=40db546e"
import script from "./UdmGrammar.vue?vue&type=script&lang=js"
export * from "./UdmGrammar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports